import { useEffect } from 'react';

import { useStores } from '../../../stores/useStores';

import { useScrollContainer } from './ScrollContainerContext';

export function useGamesSeen(listener: () => void) {
  const { categoriesStore } = useStores();
  const scrollContainer = useScrollContainer();

  const { categoriesIds, loading, currentCategory } = categoriesStore;
  const isLoading = loading.get('categories');
  const gamesCount = currentCategory?.subCategoryGames.length ?? 0;

  useEffect(() => {
    const target = scrollContainer ?? window;
    target.addEventListener('scroll', listener);
    return () => {
      target.removeEventListener('scroll', listener);
    };
  }, [scrollContainer, listener]);

  useEffect(() => {
    if (!isLoading && categoriesIds.length > 0) {
      const timeoutId = setTimeout(listener, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [listener, isLoading, categoriesIds, categoriesStore.currentId, gamesCount]);
}
